import script from "./Tasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=7bb944b3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb944b3"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
